import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../../commonButton";
import withModal from "../../withModal";
import InputField from "../../form/InputField";

const AboutModalInner = ({ onClose, onSubmit, about, isLoading }) => {
  const [aboutText, setAboutText] = useState("");

  useEffect(() => {
    setAboutText(about || "");
  }, [about]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoading) return;

    onSubmit(aboutText);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Modal.Body className="grid row-gap-3">
        <InputField
          className="g-col-12"
          label={{ name: "About Info" }}
          input={{
            as: "textarea",
            rows: 6,
            name: "about",
            value: aboutText,
            onChange: (e) => setAboutText(e.target.value),
            placeholder: "Write something about yourself...",
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <CommonButton
          type="button"
          variant="outline"
          title="Cancel"
          onClick={onClose}
          disabled={isLoading}
        />
        <CommonButton
          type="submit"
          variant="primary"
          title="Update"
          isLoading={isLoading}
        />
      </Modal.Footer>
    </Form>
  );
};

export default withModal(AboutModalInner);
